import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import Phone from '../../../components/stateless/Phone';
import Address from '../../../components/stateless/Address';
import FacilityName from '../../../components/stateless/FacilityName';
import useCurrentPage from '../../../hooks/useCurrentPage';
import { TRACK_CLICK_FACILITY_INFO_CALL } from '../../../../src/web/utils/dataLayer';
import styles from './styles.scss';

const propTypes = {
  facility: PropTypes.shape({
    address: PropTypes.shape({
      address1: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postal: PropTypes.string.isRequired,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    }).isRequired,
    phone: PropTypes.string.isRequired,
    primaryImage: PropTypes.string,
  }),
};

const defaultProps = {
  facility: undefined,
};

const FacilityInformation = ({ facility }) => {
  const renderAddressDescription = (settings) => {
    if (settings && settings.businessAddressDescription) {
      return (
        <div className={styles.addressDescription}>
          {settings.businessAddressDescription}
        </div>
      );
    }
    return '';
  };

  const renderTagline = (settings) => {
    if (settings && settings.tagline) {
      return (
        <div className={styles.tagline}>{settings.tagline}</div>
      );
    }
    return '';
  };

  const { primaryColorClass, secondaryColorClass } = useCurrentPage();

  if (!facility) {
    // TODO: Maybe show a loading thing of some kind
    return false;
  }

  return (
    <div className={styles.root}>
      <div className={`${styles.name} ${primaryColorClass}`}>
        <FacilityName {...facility} />
      </div>
      {renderAddressDescription(facility.settings)}
      <Address {...facility.address} multiLine className={styles.address} />
      <Phone
        number={facility.phone}
        className={`${styles.phone} ${secondaryColorClass}`}
        href={`tel:${facility.phone.replace(/[^\d]+/ig, '')}`}
        {...TRACK_CLICK_FACILITY_INFO_CALL}
      />
      {renderTagline(facility.settings)}
    </div>
  );
};

FacilityInformation.propTypes = propTypes;
FacilityInformation.defaultProps = defaultProps;

FacilityInformation.fragments = {
  facility: gql`
    fragment FacilityInformationFacility on Facility {
      address {
        ...FacilityAddress
      }
      ...FacilityPhone
      ...FacilityNameFacility
      primaryImage
      applicableFeesEnabled
      settings {
        businessAddressDescription
        tagline
      }
    }
    ${Address.fragments.address}
    ${Phone.fragments.facility}
    ${FacilityName.fragments.facility}
  `,
};

export default FacilityInformation;
